if (!customElements.get('product-ymm-dropdowns')) {
  class ProductYmmDropdowns extends HTMLElement {
    connectedCallback() {
      this._yearSelect = this.querySelector('#pymm-year');
      this._makeSelect = this.querySelector('#pymm-make');
      this._modelSelect = this.querySelector('#pymm-model');
      this._checkBtn = this.querySelector('.pymm-btn-check');
      this._noFitMsg = this.querySelector('.pymm-status--no-fit');
      this._fitsMsg = this.querySelector('.pymm-status--fits');
      this._buttonsEl = this.querySelector('.pymm-buttons');
      this._findBtn = this.querySelector('.pymm-btn-find');

      this._collectionUrl = this.dataset.collectionUrl || '/collections/all';
      this._productId = this.dataset.productId || null;
      this._ymmData = null;

      this._yearSelect.addEventListener('change', () => this._onYearChange());
      this._makeSelect.addEventListener('change', () => this._onMakeChange());
      this._modelSelect.addEventListener('change', () => this._onModelChange());
      this._checkBtn.addEventListener('click', () => this._onCheckClick());

      this._loadData();
    }

    async _loadData() {
      if (window.ymm_file_url) {
        this._ymmData = await this._fetchYmmData(window.ymm_file_url);
      }
      this._populateYears();
    }

    async _fetchYmmData(url) {
      window.__ymmCache = window.__ymmCache || {};
      if (!window.__ymmCache[url]) {
        window.__ymmCache[url] = fetch(url)
          .then(r => r.json())
          .catch(err => {
            console.error('[product-ymm-dropdowns] Failed to load YMM data:', err);
            return null;
          });
      }
      return window.__ymmCache[url];
    }

    get _hierarchy() {
      return this._ymmData?.hierarchy || {};
    }

    get _years() {
      return this._ymmData?.years || [];
    }

    _populateYears() {
      const years = this._years;
      this._yearSelect.innerHTML = '<option value="">Select year</option>';
      years.forEach(year => {
        const opt = document.createElement('option');
        opt.value = year;
        opt.textContent = year;
        this._yearSelect.appendChild(opt);
      });
      this._yearSelect.disabled = false;
    }

    _onYearChange() {
      const year = this._yearSelect.value;
      this._makeSelect.innerHTML = '<option value="">Select Make</option>';
      this._makeSelect.disabled = true;
      this._modelSelect.innerHTML = '<option value="">Select Model</option>';
      this._modelSelect.disabled = true;
      this._checkBtn.disabled = true;
      this._hideResults();

      if (!year) return;
      const yearData = this._hierarchy[year];
      if (!yearData) return;

      Object.values(yearData).forEach(make => {
        const opt = document.createElement('option');
        opt.value = make.value;
        opt.textContent = make.label;
        this._makeSelect.appendChild(opt);
      });
      this._makeSelect.disabled = false;
    }

    _onMakeChange() {
      const year = this._yearSelect.value;
      const make = this._makeSelect.value;
      this._modelSelect.innerHTML = '<option value="">Select Model</option>';
      this._modelSelect.disabled = true;
      this._checkBtn.disabled = true;
      this._hideResults();

      if (!make) return;
      const models = this._hierarchy[year]?.[make]?.models;
      if (!models) return;

      Object.values(models).forEach(model => {
        const opt = document.createElement('option');
        opt.value = model.value;
        opt.textContent = model.label;
        this._modelSelect.appendChild(opt);
      });
      this._modelSelect.disabled = false;
    }

    _onModelChange() {
      this._hideResults();
      this._checkBtn.disabled = !this._modelSelect.value;
    }

    async _onCheckClick() {
      const year = this._yearSelect.value;
      const make = this._makeSelect.value;
      const model = this._modelSelect.value;

      if (!year || !make || !model || !this._productId) return;

      this._checkBtn.disabled = true;
      this._checkBtn.textContent = 'Checking…';

      try {
        const params = new URLSearchParams({ year, make, model, productId: this._productId });
        const response = await fetch(`/a/minion/compatibility?${params}`);
        const data = await response.json();

        if (data.compatible) {
          this._fitsMsg.hidden = false;
          this._noFitMsg.hidden = true;
          this._buttonsEl.hidden = true;
        } else {
          this._noFitMsg.hidden = false;
          this._fitsMsg.hidden = true;
          this._updateFindLink(year, make, model);
          this._buttonsEl.hidden = false;
        }
      } catch (err) {
        console.error('[product-ymm-dropdowns] Compatibility check failed:', err);
      } finally {
        this._checkBtn.disabled = false;
        this._checkBtn.textContent = 'CHECK COMPATIBILITY';
      }
    }

    _hideResults() {
      this._noFitMsg.hidden = true;
      this._fitsMsg.hidden = true;
      this._buttonsEl.hidden = true;
    }

    _updateFindLink(year, make, model) {
      if (!this._findBtn) return;
      const params = new URLSearchParams();
      if (year) params.set('year', year);
      if (make) params.set('make', make);
      if (model) params.set('model', model);
      this._findBtn.href = `${this._collectionUrl}?${params}`;
    }
  }

  customElements.define('product-ymm-dropdowns', ProductYmmDropdowns);
}
